import $ from 'jquery';
import slick from 'slick-carousel';

$(() => {
  $('#load-more').on('click', (e) => {
    e.preventDefault();

    // retrieve page
    const currentPage = $('#load-more').data('page');
    console.log(currentPage);

    $.ajax({
      url: morenoBlog.ajax_url,
      type: 'post',
      data: {
        action: 'load_more_posts',
        nonce: morenoBlog.nonce,
        page: currentPage,
      },
      beforeSend: () => {
        $('#load-more').text('Caricamento...');
      },
      success: (response) => {
        console.log(response);

        if (response.success) {
          $('#post-grid').append(response.data.posts);
          $('#load-more').data('page', currentPage + 1);

          if (!response.data.has_next) {
            $('#load-more').hide();
          }
        } else {
          console.log(response.data.message);
          $('#load-more').hide();
        }
        $('#load-more').text('Carica di più');
      },
      error: (response) => {
        console.log(response);
        $('#load-more').hide();
      }
    });
  });

  /** Related vehicles - posts **/
  $('.post-related-vehicles').each(function (index, sliderWrap) {
    let slider = $(sliderWrap).find('.vehicles-gallery');
    let prev = $(sliderWrap).find('.slick-prev');
    let next = $(sliderWrap).find('.slick-next');

    slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 300,
      arrows: true,
      infinite: true,
      centerMode: false,
      nextArrow: next,
      prevArrow: prev,
      rows: 0,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  });
});
